/* eslint-disable no-constant-condition */
import cn from 'classnames';
import * as React from 'react';
import * as bjTypes from '@api/types/blackjack';
import * as bjUtils from '@utils/blackjack';
import { getUserIdFromToken } from '@utils/utils';
import styles from './player.module.scss';

export interface IMockedPlayer {
  user: { username: string; avatar_url: string; id: string };
  cards: bjTypes.IBlackjackPlayerCardsObject[];
  tickets: { roll: number }[];
  ready_to_play: boolean;
  winner: boolean;
  status: bjTypes.TBlackjackGameStatus;
}

interface IPlayerItem {
  player?: IMockedPlayer;
  playerNumber: number;
}

interface IPlayerContext extends IPlayerItem {
  isReversed: boolean;
  positionInTable: bjTypes.IBlackjackPlayerPosition;
  currentPlayerId: string;
}

export interface IProps extends IPlayerItem {
  children: React.ReactElement | React.ReactElement[];
}

const MAX_PLAYERS = 7;

export const PlayerContext: React.Context<IPlayerContext> = React.createContext(
  {} as IPlayerContext
);

export const getPositionClasses = (
  className: string,
  position: bjTypes.IBlackjackPlayerPosition
): string =>
  cn(styles[className], {
    [styles[`${className}-position-${position}`]]: position,
  });

export const getReversedClasses = (
  className: string,
  isReversed: boolean
): string =>
  cn(styles[className], {
    [styles.reversed]: isReversed,
  });

const Player = ({ player, playerNumber, children }: IProps): JSX.Element => {
  const positionInTable: bjTypes.IBlackjackPlayerPosition =
    bjUtils.getPlayerPositionInTable(
      MAX_PLAYERS as bjTypes.TMaxPlayers,
      playerNumber
    );

  const currentPlayerId: string = getUserIdFromToken();

  const isReversed: boolean =
    positionInTable === 'BC' ||
    positionInTable === 'BR' ||
    positionInTable === 'MR' ||
    positionInTable === 'TR';

  /* ClassNames */

  const containerClasses: string = getPositionClasses(
    'player',
    positionInTable
  );

  const contextValue: IPlayerContext = {
    currentPlayerId,
    isReversed,
    player,
    playerNumber,
    positionInTable,
  };

  return (
    <PlayerContext.Provider value={contextValue}>
      <div className={containerClasses}>{children}</div>
    </PlayerContext.Provider>
  );
};

export default Player;
